import { render, staticRenderFns } from "./SetBaseForm.vue?vue&type=template&id=0c3a942c"
import script from "./SetBaseForm.vue?vue&type=script&lang=js"
export * from "./SetBaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports